module.exports = __webpack_public_path__ + "media/images/lb/541-7e011e5a193b86885cd649b198e2e262.svg";